import React, { useState } from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';
import omit from 'lodash/omit';

import RadioButton, { radioButtonPropTypes } from './RadioButton';

/**
 * This component is responsible for handling the selected state for a group of
 * radio buttons.
 */
const RadioButtonGroup = ({
  className,
  defaultValue,
  inline,
  onChange,
  name,
  radioButtonProps,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  const handleChange = event => {
    setSelectedValue(event.target.value);
    onChange && onChange(event);
  };

  const RadioButtons = () => {
    return radioButtonProps.map(props => {
      const checked = selectedValue === props.value;

      return (
        <RadioButton
          checked={checked}
          key={props.value}
          name={name}
          onChange={handleChange}
          {...props}
        />
      );
    });
  };

  const groupClasses = classNames(className, 'radio-button-group', {
    'radio-button-group--inline': !!inline,
  });

  return (
    <div className={groupClasses}>
      <RadioButtons />
    </div>
  );
};

RadioButtonGroup.propTypes = {
  className: propTypes.string,
  defaultValue: propTypes.string,
  inline: propTypes.bool,
  name: propTypes.string.isRequired,
  onChange: propTypes.func,
  radioButtonProps: propTypes.arrayOf(
    propTypes.shape(omit(radioButtonPropTypes, ['checked', 'name', 'onChange']))
  ).isRequired,
};

export default RadioButtonGroup;
